import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Loader2, Compass, ArrowRight } from "lucide-react";
import api from "@/lib/api";
import ReportContent from "@/components/ReportContent";
import { Button } from "@/components/ui/button";

const SharedReport = () => {
  const { shareId } = useParams();
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    const load = async () => {
      try { const res = await api.get(`/shared/${shareId}`); setData(res.data); }
      catch (e) { setNotFound(true); }
      finally { setBusy(false); }
    };
    load();
  }, [shareId]);

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <header className="sticky top-0 z-50 backdrop-blur-xl bg-white/70 border-b border-white/40">
        <div className="max-w-5xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2" data-testid="shared-logo">
            <div className="w-9 h-9 rounded-xl bg-primary flex items-center justify-center">
              <Compass className="w-5 h-5 text-white" />
            </div>
            <span className="font-heading font-extrabold text-lg text-slate-900">CareerCompass</span>
          </Link>
          <Link to="/">
            <Button className="rounded-xl font-heading font-bold" data-testid="shared-cta">
              Take your own <ArrowRight className="w-4 h-4 ml-1" />
            </Button>
          </Link>
        </div>
      </header>

      <div className="max-w-5xl mx-auto px-5 sm:px-8 py-8">
        {busy ? (
          <div className="flex items-center justify-center h-[60vh]"><Loader2 className="w-8 h-8 animate-spin text-primary" /></div>
        ) : notFound ? (
          <div className="text-center py-24" data-testid="shared-not-found">
            <Compass className="w-12 h-12 text-slate-300 mx-auto mb-4" />
            <h1 className="font-heading font-extrabold text-2xl text-slate-900">Report not found</h1>
            <p className="font-body text-slate-500 mt-2">This shared link may have expired or is invalid.</p>
          </div>
        ) : (
          <>
            {data.sharer_name && (
              <p className="font-body text-sm text-slate-500 mb-4" data-testid="shared-sharer">
                Shared career report from <span className="font-semibold text-slate-700">{data.sharer_name}</span>
              </p>
            )}
            <ReportContent data={data} />
          </>
        )}
      </div>
    </div>
  );
};

export default SharedReport;
